// The Source filter on the Rules screen (owner, 2026-10-16 — D-367): "Rules"
// for what a person wrote, "Memory" for what the system wrote down on its own —
// a vendor name or a line's Account remembered from an invoice that reached
// Point Click Care, a routing rule an Override created, and vendor guidance
// written from corrections. One vocabulary for every tab, and every tab opens
// on Rules alone, so Memory never crowds out what people wrote.
//
// Shared code rather than a copy per tab, for the reason `statusFilter.ts`
// gives: "Rules is the default" has to hold everywhere.

/** One Source box. */
type RuleSourceValue = 'rules' | 'memory'

export const RULE_SOURCE_OPTIONS: readonly { value: RuleSourceValue; label: string }[] = [
  { value: 'rules', label: 'Rules' },
  { value: 'memory', label: 'Memory' },
]

/** Where every tab opens, and where Reset returns it. */
export const DEFAULT_RULE_SOURCE_FILTER: string[] = ['rules']

/** Does a row pass the ticked boxes? Nothing ticked does not narrow, as with every multi-select. */
export function matchesRuleSource(filter: readonly string[], isMemory: boolean): boolean {
  if (filter.length === 0) return true
  return filter.includes(isMemory ? 'memory' : 'rules')
}
